import React, { SVGProps } from 'react';

export const AiEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.384 6.304a3.057 3.057 0 0 1-2.105-2.106l-.39-1.364A.931.931 0 0 0 18 2.166a.931.931 0 0 0-.888.668l-.39 1.357a3.04 3.04 0 0 1-2.097 2.106l-1.35.385a.933.933 0 0 0-.675.89c0 .412.276.777.666.892l1.35.391a3.051 3.051 0 0 1 2.105 2.106l.382 1.357a.901.901 0 0 0 .888.648.92.92 0 0 0 .897-.648l.382-1.357a3.051 3.051 0 0 1 2.105-2.106l1.35-.385a.939.939 0 0 0 .657-.7.937.937 0 0 0-.63-1.075c-.003 0-.006-.002-.008-.003l-.008-.002-.002-.001v.006l-1.35-.391Zm-1.58 1.274A4.842 4.842 0 0 1 18 5.767a4.824 4.824 0 0 1-1.81 1.81 4.84 4.84 0 0 1 1.804 1.805 4.84 4.84 0 0 1 1.81-1.804Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m9.752 17.64-7.293-5.848A37.653 37.653 0 0 0 2.4 14.16c0 1.74.057 2.929.228 3.78.163.811.39 1.117.593 1.287.246.206.736.447 1.851.604 1.108.157 2.602.203 4.678.203s3.57-.046 4.678-.203c1.115-.157 1.605-.398 1.851-.604.203-.17.43-.476.593-1.287.14-.695.203-1.614.222-2.874h1.8c-.086 6.114-1.223 6.768-9.144 6.768-8.296 0-9.15-.717-9.15-7.674 0-6.957.856-7.674 9.15-7.674.364 0 .714.001 1.05.005v1.8c-.332-.004-.682-.005-1.05-.005-2.075 0-3.57.047-4.677.203-1.115.158-1.606.398-1.852.604-.14.118-.29.299-.424.663l6.951 5.575 4.427-3.571 1.152 1.383-5.575 4.498Z"
    />
  </svg>
);
